const NewsSingle = () => {
    const reportsCat = document.querySelector('.template-single-reports');
    if (!reportsCat) return;

    // Find any groups with 10% padding
    const wpBlockGroup = document.querySelectorAll('.wp-block-group.is-style-container');
    if (wpBlockGroup) {
        wpBlockGroup.forEach((block) => {
            const inlinePaddingTop = block.style.paddingTop;
            const inlinePaddingBottom = block.style.paddingBottom;

			// If the group has 10% padding, change it to 5%
            if (inlinePaddingTop === '10%' && inlinePaddingBottom === '10%') {
                block.style.paddingTop = '5%';
                block.style.paddingBottom = '5%';
            }
        });
    }
}

export default NewsSingle;